import { TaasMenuItem } from "utimaco-common-ui-angular";
import { environment } from '../environments/environment';

// see https://netbasal.com/simplifying-file-imports-in-angular-with-new-loader-options-4e94a0eb18af for importing svgs in angular ^17.1
import appsIcon from '../assets/icon_app.svg';
import cartIcon from '../assets/icon_shopping_cart.svg';
import groupIcon from '../assets/icon_group.svg';
import descriptionIcon from '../assets/icon_description.svg';
import helpIcon from '../assets/icon_help.svg';
import quizIcon from '../assets/icon_quiz.svg';
import receiptLongIcon from '../assets/icon_receipt.svg';
import accountBalanceIcon from '../assets/icon_account_balance.svg';
import supportAgentIcon from '../assets/icon_support_agent.svg';

export function getMenuItems(userRoles: string[]): TaasMenuItem[] {
  const marketplaceLink = environment.marketplaceUrl;
  const dmsLink = environment.dmsUrl;
  const featureScope = environment.featureScope;

  const menuItems: TaasMenuItem[] = [];


  /** 
   * IMPORTANT NOTE ON MODIFYING THE REQUIRED ROLES 
   * if requiredRoles are updated here this will only affect the rendering of the menu items. 
   * You still also need to update the routes to reflect the changes as well with the same roles, 
   * otherwise the user will see the menu item but cannot navigate to the site
   */
  menuItems.push({ id: 0, type: "link", active: true, name: $localize`Services & Products`, link: "/", iconSvg: appsIcon, children: [] });
  if (featureScope != "LA")
    menuItems.push({ id: 1, type: "link", active: false, name: $localize`Marketplace`, link: marketplaceLink, iconSvg: cartIcon, children: [] });

  menuItems.push({ id: 2, type: "link", active: false, name: $localize`Documents & Downloads`, link: dmsLink, iconSvg: descriptionIcon, children: [] });
  menuItems.push({ id: 3, type: "link", active: false, name: $localize`User Management`, link: "/users", iconSvg: groupIcon, requiredRoles: ["global-org-admin", "TaasPortalApi:org-admin"], children: [] });

  if (featureScope != "LA")
    menuItems.push({
      id: 4, type: "section", active: false, name: $localize`Support`, link: "/support", iconSvg: helpIcon, children: [
        { id: 5, type: "link", active: false, name: $localize`Knowledgebase`, link: "/support/knowledgebase", iconSvg: quizIcon, children: [] },
        { id: 6, type: "link", active: false, name: $localize`Tickets`, link: "/support/tickets", iconSvg: supportAgentIcon, children: [] },
      ]
    });
  /*
  {
      id: 6, type: "section", active: false, name: $localize`Contracts`, link: "/legal", matIconName: "privacy_tip", children: [
          { id: 7, type: "link", active: false, name: $localize`General`, link: "/legal/public", matIconName: "document_scanner", children: [] },
          { id: 8, type: "link", active: false, name: $localize`Private`, link: "/legal/private", matIconName: "document_scanner", children: [] },
      ]
  },
  */
  if (featureScope != "LA")
    menuItems.push(
      {
        id: 9, type: "section", active: false, name: $localize`Billing`, link: "/billing", iconSvg: receiptLongIcon, requiredRoles: ["global-org-admin", "TaasPortalApi:billing-contributor", "TaasPortalApi:billing-viewer"], children: [
          { id: 10, type: "link", active: false, name: $localize`Billing Profiles`, link: "/billing/billingProfiles", iconSvg: accountBalanceIcon, requiredRoles: ["global-org-admin", "TaasPortalApi:billing-contributor", "TaasPortalApi:billing-viewer"], children: [] },
          { id: 11, type: "link", active: false, name: $localize`Invoices`, link: "/billing/invoices", iconSvg: receiptLongIcon, children: [], requiredRoles: ["global-org-admin", "TaasPortalApi:billing-contributor", "TaasPortalApi:billing-viewer"] }
        ]
      }
    );

  //filter out all items where requiredRoles are defined but user does not have the roles
  const filteredMenuItems = menuItems.filter(menuItem => !menuItem.requiredRoles || menuItem.requiredRoles.some(role => userRoles.includes(role)));
  // filter second level entries
  filteredMenuItems.map(menuItem => {
    menuItem.children = menuItem.children.filter(childItem => !childItem.requiredRoles || childItem.requiredRoles.some(role => userRoles.includes(role)));
  });

  return filteredMenuItems;
}
